import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {AuthService} from '../../../../shared/services/auth.service';
import {takeUntil} from 'rxjs/operators';
import {ConfirmDialogComponent} from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import {CommissionRedirection} from '../../../../shared/interface/commission-redirection';
import {CommissionRedirectionService} from '../../../../shared/services/commission-redirection.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ChangeRatePaidDialogComponent} from '../change-rate-paid-dialog/change-rate-paid-dialog.component';

@Component({
  selector: 'app-redirection-details-view',
  templateUrl: './redirection-details-view.component.html',
  styleUrls: ['./redirection-details-view.component.scss']
})
export class RedirectionDetailsViewComponent implements OnInit, OnDestroy {
  @Input() commissionRedirection: Observable<CommissionRedirection>;
  @Output() modifyClicked = new EventEmitter<any>();
  @Output() changed = new EventEmitter<any>();

  commissionRedirectionObject?: CommissionRedirection;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private commissionRedirectionService: CommissionRedirectionService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.commissionRedirection
      .pipe(takeUntil(this.destroyed$))
      .subscribe((commissionRedirection: CommissionRedirection) => {
        this.commissionRedirectionObject = commissionRedirection;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć przepięcie?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commissionRedirectionService.delete(this.commissionRedirectionObject.uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto przepięcie', '', {duration: 2000});
              this.router.navigate(['/przepiecia-polis']);
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 2000});
            }
          });
      }
    });
  }

  modifyRatePaid(): void {
    const dialogRef = this.dialog.open(ChangeRatePaidDialogComponent, {
      width: '400px',
      maxHeight: '80vh',
      data: {commissionRedirection: this.commissionRedirectionObject},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.changed.emit();
      }
    });
  }
}
